import {
    FETCH_NOTIFICATION
} from '../actions/types';

export const reducer = (state = {}, action) => {

    switch (action.type) {
        case FETCH_NOTIFICATION:
            return { ...state, homePageNotification: action.payload}
        default:
            return state;
    }
};
